import type { AiMode } from "../types/openclaw";

// Subscription tenants draw on a flat-rate allowance, so the usage sampler
// records no chat spend for them; an empty series is expected, not a gap.
export const isUnmeteredAi = (aiMode: AiMode | undefined): boolean => aiMode === "chatgpt" || aiMode === "claude";

export const spendEmptyText = (aiMode: AiMode | undefined): string =>
  aiMode === "claude" ? "On a Claude subscription, so chat usage isn't metered here."
    : isUnmeteredAi(aiMode) ? "On a ChatGPT subscription, so chat usage isn't metered here." : "No spend samples yet.";
